// @ts-nocheck

import React from 'react'
import AvatarEditor from 'react-avatar-editor'
import Dropzone from 'react-dropzone'
import { ButtonOLD } from '@lmc/ui-kit'
import { Modal } from 'antd'
import { isIE, isEdge } from 'react-device-detect'
import Swal from 'sweetalert2'
import { Row } from 'antd'
import Glyph from '../../../LEGACY/Glyph'

class AvatarUpload extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      scale: 1,
      rotation: 0,
    }
  }

  handleDrop = (dropped) => {
    this.setState({ image: dropped[0] })
  }

  renderDropZoneActive = () => (
    <div className="dropzone-text dropzone__active">
      <p>{DROP_ZONE_ACTIVE}</p>
    </div>
  )

  renderDropZoneRejected = () => (
    <div className="dropzone-text dropzone__rejected">
      <p>{DROP_ZONE_REJECTED}</p>
    </div>
  )

  renderDropZoneInactive = () => (
    <div
      className="dropzone-text dropzone__inactive"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <ButtonOLD
        type="primary"
        glyph="cloud-upload"
        icon={<Glyph name="cloud-upload" />}
        style={{ justifyContent: 'center' }}
        // onClick={() => this.exportPdf(logs, resident)}
      >
        {DROP_ZONE_BUTTON}
      </ButtonOLD>
      <p>{DROP_ZONE_INACTIVE}</p>
    </div>
  )

  handleScale = (e) => {
    const scale = parseFloat(e.target.value)
    this.setState({ scale })
  }

  setRotation = (rotation) => {
    this.setState({
      rotation: this.state.rotation + rotation,
    })
  }

  save = (event) => {
    const { onClose, onSave } = this.props
    event.preventDefault()
    this.editor.getImageScaledToCanvas().toBlob((blob) => {
      const file = new File(
        [blob],
        this.state.image.name.replace(/\..+$/, '.png'),
        { type: 'image/png' }
      )
      const imageUri = window.URL.createObjectURL(blob)
      onSave(file, imageUri)
      onClose ? onClose() : this.toggleModal()
    })
  }

  renderAvatarEditor = () => {
    return (
      <div>
        <ButtonOLD
          link
          backArrow
          type="default"
          onClick={() => this.setState({ image: null, scale: 1 })}
          style={{ paddingLeft: 0 }}
        >
          Back
        </ButtonOLD>
        <div style={styles.imageContainer}>
          <AvatarEditor
            scale={parseFloat(this.state.scale)}
            ref={(editor) => {
              this.editor = editor
            }}
            width={200}
            height={200}
            border={0}
            borderRadius={125}
            rotate={this.state.rotation}
            image={this.state.image}
          />

          <div>
            <div style={styles.zoomContainer}>
              <span style={styles.zoomLabel}>-</span>
              <div style={styles.zoomSlider}>
                <input
                  name="scale"
                  type="range"
                  onChange={this.handleScale}
                  min="1"
                  max="4"
                  step="0.01"
                  style={styles.zoomInput}
                  defaultValue="1"
                />
              </div>
              <span style={styles.zoomLabel}>+</span>
            </div>
            <Row justify="center">
              <ButtonOLD
                style={styles.rotateBtn}
                type="secondary"
                onClick={() => this.setRotation(-90)}
              >
                Rotate Left
              </ButtonOLD>
              <ButtonOLD
                style={styles.rotateBtn}
                type="secondary"
                onClick={() => this.setRotation(90)}
              >
                Rotate Right
              </ButtonOLD>
            </Row>
          </div>
        </div>
      </div>
    )
  }

  toggleModal = () => {
    if (isIE || isEdge) {
      return this.renderBrowserAlert()
    }
    this.setState({
      image: null,
      scale: 1,
      isModalOpen: !this.state.isModalOpen,
    })
  }

  renderDropZoneArea = ({ isDragActive, isDragReject }) => {
    if (isDragActive) {
      return this.renderDropZoneActive()
    } if (isDragReject) {
      return this.renderDropZoneRejected()
    } 
      return this.renderDropZoneInactive()
    
  }

  renderDropZone = () => (
    <Dropzone
      accept=".png,.jpg,.jpeg"
      onDrop={this.handleDrop}
      multiple={false}
    >
      {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
        <section>
          <div className="dropzone" {...getRootProps()}>
            <input {...getInputProps()} />
            {this.renderDropZoneInactive({ isDragActive, isDragReject })}
          </div>
        </section>
      )}
    </Dropzone>
  )

  renderBrowserAlert = () => {
    return Swal.fire({
      title: 'Oops!',
      html: "Looks like you're using a browser that doesn't support this feature of Log my Care.<br/><br/>Please use <a href='https://www.google.com/chrome/'>Google Chrome</a>, <a href='https://www.mozilla.org/en-GB/firefox/new/'>Firefox</a>, or <a href='https://www.apple.com/uk/safari/'>Safari</a> instead.",
      type: 'info',
      confirmButtonText: 'OK',
    })
  }

  renderModal = () => {
    const { customButton, isModalOpen, onClose } = this.props
    const isOpen = customButton ? isModalOpen : this.state.isModalOpen
    return (
      <Modal
        title={OPEN_MODAL_TEXT}
        open={isOpen}
        onCancel={onClose || this.toggleModal}
        footer={[
          <ButtonOLD
            type="secondary"
            data-button-type="cancel"
            onClick={onClose || this.toggleModal}
          >
            {BUTTON_CANCEL}
          </ButtonOLD>,
          this.state.image && (
            <ButtonOLD
              type="primary"
              data-button-type="submit"
              onClick={this.save}
              style={styles.uploadButton}
            >
              {BUTTON_SAVE}
            </ButtonOLD>
          ),
        ]}
      >
        {this.state.image ? this.renderAvatarEditor() : this.renderDropZone()}
      </Modal>
    )
  }

  render = () => (
    <div>
      {!this.props.customButton && (
        <div style={styles.container}>
          <ButtonOLD
            type="primary"
            onClick={this.toggleModal}
            icon={<Glyph name="cloud-upload" />}
          >
            {OPEN_MODAL_TEXT}
          </ButtonOLD>
        </div>
      )}
      {this.renderModal()}
    </div>
  )
}

const DROP_ZONE_ACTIVE = 'Drop to upload'
const DROP_ZONE_INACTIVE = 'or drop your image here'
const DROP_ZONE_REJECTED =
  "That's not a valid file type. Please try a PNG or JPG."
const DROP_ZONE_BUTTON = 'Upload Image'
const OPEN_MODAL_TEXT = 'Set profile picture'
const BUTTON_SAVE = 'Upload'
const BUTTON_CANCEL = 'Cancel'

const styles = {
  container: {
    paddingLeft: 180,
    paddingBottom: 16,
  },
  imageContainer: {
    textAlign: 'center',
  },
  zoomInput: {
    width: '80%',
  },
  zoomContainer: {
    maxWidth: 220,
    margin: '0 auto',
  },
  zoomLabel: {
    margin: 5,
    textAlign: 'center',
    position: 'relative',
    top: -3,
  },
  zoomSlider: {
    display: 'inline',
    paddingTop: 5,
  },
  rotateBtn: {
    margin: '15px 5px',
  },
  uploadButton: {
    marginLeft: 8,
  },
}

export default AvatarUpload
